/** colors **/
export const backgroundPrimaryColor = "white"

export const primaryColor = "#92d6c1"
export const primaryColorWithOpacity = (opacity: number) => `rgba(146,214,193,${opacity})`
export const primaryLightColor = "#d4eadc"
export const primaryDarkColor = "#318269"
export const primaryDarkColor15Darker = "#296e59" // 15% darker than 318269

export const darkButtonColor = "#343a40"
export const darkButtonHoverColor = "#23272b"

export const weatherGood = "green"
export const weatherAverage = "#f5c71a"
export const weatherBad = "red"
export const weatherAutumn = "#fc8769"
export const weatherSki = "#88c5fd"

export const fillMap = "#d4edf5"

/** sizes **/
export const menuHeight = "35px"
export const headerIconSize = "18px"
export const bannerHeight = `calc(100vh / 9.425)`
export const bannerHeightLandscape = `calc(100vh / 7)` // random :)
export const pageDesktopHeightWithoutBanner = `calc(100vh - ${bannerHeight} - ${menuHeight})`
export const pageMobileHeightWithoutBanner = `calc(100vh - ${bannerHeight})`
export const pageMobileLandscapeHeightWithoutBanner = `calc(100vh - ${bannerHeightLandscape})`

export const mobileEnd = "576px"
export const maxWidthSmallContainer = 540
export const smallStartSize = 577
export const smallStart = `${smallStartSize}px`
export const smallEnd = "768px"
export const maxWidthMediumContainer = 720
export const mediumStartSize = 769
export const mediumStart = `${mediumStartSize}px`
export const mediumEnd = "992px"
export const maxWidthLargeContainer = 960
export const largeStartSize = 993
export const largeStart = `${largeStartSize}px`
export const largeEnd = `1199px`
export const maxWidthExtraLargeContainer = 1140
export const extraLargeStartSize = 1200
export const extraLargeStart = `${extraLargeStartSize}px`

export const maxWidth = 1425 // used on home page
